module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Fachfirmen","group-title-data-management":"Datenverwalten"},"fr":{"group-title-data-management":"Gestion des données","title":"Entreprises spécialisées"},"it":{"group-title-data-management":"Gestione dati","title":"Aziende specializzate"}}')
  delete Component.options._Ctor
}
